import { Check, Clock, AlertCircle, CheckCheck, XCircle } from 'lucide-react';
import { cn } from '@/lib/utils';
import { getMessageStatusInfo } from '@/lib/message-utils';
import type { Message } from '@/types/message-types';

interface MessageStatusIconProps {
  message: Message;
  className?: string;
}

export function MessageStatusIcon({ message, className }: MessageStatusIconProps) {
  const statusInfo = getMessageStatusInfo(message);
  
  const getIcon = () => {
    switch (statusInfo.icon) {
      case 'clock':
        return <Clock className={cn("h-3 w-3", statusInfo.color, className)} />;
      case 'check':
        return <Check className={cn("h-3 w-3", statusInfo.color, className)} />;
      case 'check-check':
        return (
          <div className={cn("relative inline-flex", className)}>
            <Check className={cn("h-3 w-3", statusInfo.color)} />
            <Check className={cn("h-3 w-3 absolute left-1 top-0", statusInfo.color)} />
          </div>
        );
      case 'x-circle':
        return <XCircle className={cn("h-3 w-3", statusInfo.color, className)} />;
      default:
        return <Clock className={cn("h-3 w-3", statusInfo.color, className)} />;
    }
  };

  return (
    <div title={statusInfo.tooltip}>
      {getIcon()}
    </div>
  );
}